export default[
    '/whale-pc/fileUpload/file/uploadFile',
    '/whale-merge-pc/fileUpload/file/uploadFile',
    '/oms-consignor-pc/consignor/address/saveExcel',
    '/oms-consignor-pc/settle/apply/consignor/uploadExcel',
    '/oms-consignor-pc/order/importOrder/excelImportOrderStepOne',  
    '/oms-consignor-pc/order/importTenderOrder/excelImportTenderOrderStepOne',     
    '/oms-consignor-pc/order/importHugeOrder/excelImportHugeOrderStepOne',       
    '/oms-consignor-pc/order/importAdditionOrder/excelAdditionImportOrderStepOne',
    '/bigdata/business/dataCollect',
    '/uc-saas-api/saas/user/getTempToken',
    '/scm-oms-web-server/bookDemo/sendMail',
    '/uc-saas-api/saas/user/getToken',
    '/whale-pc/area/getCountryAreaTree',
    '/whale-pc/clue/addByPortal',
    '/whale-pc/clue/queryEnumOptionList',
    'https://scmg.zczy56.com/zczy-link-server/stream-sse'
]